import React from 'react';
import classnames from 'classnames';
import Box from '../Box/Box';

import styles from './Separator.module.scss';

type Orientation = 'horizontal' | 'vertical';
type Theme = 'dark' | 'light';

export interface SeparatorProps {
  orientation?: Orientation;
  theme?: Theme;
  showLine?: boolean | string;
  /** Additional CSS class name */
  className?: string;
}

const Separator: React.FC<SeparatorProps> = ({
  orientation = 'horizontal',
  theme = 'dark',
  showLine = true,
  className,
}) => {
  const shouldShowLine = showLine === true || showLine === 'true';

  return (
    <Box
      className={classnames(styles.separator, styles[theme], styles[orientation], className)}
      pt={12}
      pb={12}
    >
      {shouldShowLine && <Box />}
    </Box>
  );
};

Separator.displayName = 'Separator';

export default Separator;
